import { CardRule, CardType } from '@generated-types';
import { cardTypeGet, cardTypePut } from '@utils/query-utils';

import { getTypeCardBasePath } from '../common';

export const getCardRules = async (cardType: CardType, cardId: string) =>
    cardTypeGet(cardType)<CardRule>(`${getTypeCardBasePath(cardType)}/${cardId}/rule`);

export const setCardRules = async (cardType: CardType, cardId: string, cardRules: CardRule) =>
    cardTypePut(cardType)(`${getTypeCardBasePath(cardType)}/${cardId}/rule`, cardRules);
